import { mutatorAction } from "satcheljs";
import { ShiftsByMemberAndDateStore } from "sh-conflict-store";

export default mutatorAction('RESET_SHIFTS_BY_MEMBER_AND_DATE_STORE', function resetShiftsByMemberAndDateStore() {
   ShiftsByMemberAndDateStore().shiftIdToMemberDateIdsMap.clear();
   ShiftsByMemberAndDateStore().memberIdToShiftsByDate.clear();
});
